import Vue from "vue";

export function success(message) {
  Vue.toasted.show(message, {
    duration: "6000",
    type: "success"
  });
}

export function errorNotification(message) {
  Vue.toasted.show(message, {
    type: "error",
    duration: "6000",
    position: "top-right",
    action: [
      {
        text: "Close",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    ]
  });
}

export function info(message) {
  Vue.toasted.show(message, { duration: "6000", type: "info" });
}
